import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const GTM_ID = "GTM-PXXPK5K5";

export default function GTMManager() {
  const location = useLocation();

  useEffect(() => {
    const { pathname } = location;

    // should work only in prod
    const isProd = process.env.NODE_ENV === "production";

    // match pages where GTM should be active
    const shouldInjectGTM =
      pathname.startsWith("/login") ||
      pathname.startsWith("/reset-password") ||
      pathname.startsWith("/registration");

    const scriptId = "gtm-script";
    const noScriptId = "gtm-noscript";
    const hasScript = document.getElementById(scriptId);

    if (isProd && shouldInjectGTM && !hasScript) {
      // inject GTM <script> in head
      const script = document.createElement("script");
      script.id = scriptId;
      script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
        j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
        f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${GTM_ID}');
      `;
      document.head.appendChild(script);

      // inject <noscript> in body
      const noscript = document.createElement("noscript");
      noscript.id = noScriptId;
      noscript.innerHTML = `
        <iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}"
        height="0" width="0" style="display:none;visibility:hidden"></iframe>
      `;
      document.body.appendChild(noscript);
    }

    // remove GTM when navigating away or not needed
    if ((!isProd || !shouldInjectGTM) && hasScript) {
      document.getElementById(scriptId)?.remove();
      document.getElementById(noScriptId)?.remove();
    }
  }, [location]);

  return null;
}
